export default "__VITE_ASSET__27aoLYU6__"